import { render, staticRenderFns } from "./MtSuppliersModal.vue?vue&type=template&id=f1725988&"
import script from "./MtSuppliersModal.vue?vue&type=script&lang=js&"
export * from "./MtSuppliersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports